import { useEffect } from "react";
import { createPortal } from "react-dom";

const Portal = ({ children, id = "modal-root" }) => {
  let element = document.createElement("div");
  const modalRoot = document.getElementById(id);
  useEffect(() => {
    modalRoot.appendChild(element);
    return () => {
      modalRoot.removeChild(element);
    };
  }, [modalRoot, element]);

  return createPortal(children, element);
};

export default Portal;
